import React from "react";
import styled from "styled-components";

const FooterDiv = styled.div`
  text-align: center;

  margin: 0 1rem;
  margin-bottom: 1rem;
`;

const Footer = () => (
  <FooterDiv>
    &copy; 2018 Casey Lee and Adam Fishman. Developed by Casey and designed by
    Casey and Adam.
  </FooterDiv>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js